module.exports = __webpack_public_path__ + "img/champion.e8ee30ee.jpg";